<template>
  <div class="container container-table">
      <div class="row vertical-10p">
        <div class="container">
          <img src="/static/img/logo.png" class="center-block logo">
          <div class="text-center col-sm-12 col-sm-offset-3">
            <h1>Tu es perdu(e) !</h1>
            <h4>Ce quizz n'existe pas.</h4>
            <router-link to="/">Retour à la <i class="fa fa-home" aria-hidden="true"></i>.</router-link>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
  export default {
    name: 'NotFound'
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// NoQuizz.vue?7c43d2a6